export default __webpack_public_path__ + "static/162ac450c39f55561c6e76c100dbba2e.svg";